import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { divisionEntity } from "./division-entity";
import { DivisionController } from "./division-controller";
import { DivisionService } from "./division-service";


@Module({
  imports: [TypeOrmModule.forFeature([divisionEntity])],
  controllers: [DivisionController],
  providers: [DivisionService, ApplicationExceptionHandler],
})
export class DivisionModule {}
